import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useCourtFiles } from '../court-files';
import { useColumns } from './court-file-judge-office-columns';

export const COURT_FILES_JUDGE_OFFICE_IDENTIFIER = 'COURT_FILES_JUDGE_OFFICE';
export const COURT_FILES_JUDGE_OFFICE_VERSION = 15;

export function CourtFilesJudgeOffice() {
  const intl = useIntl();
  const columns = useColumns();

  const { evidenceBag } = useCourtFiles({
    evidenceProps: {
      identifier: COURT_FILES_JUDGE_OFFICE_IDENTIFIER,
      version: COURT_FILES_JUDGE_OFFICE_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.JUDGE_OFFICE,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__COURT_FILES_JUDGE_OFFICE__TABLE__TITLE',
          defaultMessage: 'Soudní spisy - Kancelář soudce',
        }),
      },
      detailProps: {
        toolbarProps: {
          showBtn: (button) => {
            if (button === 'NEW') {
              return false;
            }
            return true;
          },
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
